import React from 'react';
import PropTypes from 'prop-types';
import chroma from 'chroma-js';
import keycode from 'keycode';
import Colors from 'common/constants/colors';
import './index.scss';

export default class HexInput extends React.Component {
  static propTypes = {
    handleChange: PropTypes.func,
    value: PropTypes.string,
  };

  static defaultProps = {
    handleChange: () => {},
    handleEnter: () => {},
    value: '#fff',
  };

  constructor() {
    super();
    this.state = {
      isValid: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  getBorderColor(isValid) {
    return isValid ? Colors.gray400 : Colors.red400;
  }

  getPlaceholder(value) {
    if (value && value.length) {
      const color = chroma(value);
      const hex = color.hex();
      return hex.split('#').pop();
    }
    return '';
  }

  getTextColor(isValid) {
    return isValid ? Colors['black-modal'] : Colors.red400;
  }

  render() {
    const borderColor = this.getBorderColor(this.state.isValid);
    const textColor = this.getTextColor(this.state.isValid);
    const placeholder = this.getPlaceholder(this.props.value);
    return (
      <div
        className={'HexInput'}
        style={{
          border: `1px solid ${borderColor}`,
        }}>
        <div className={'HexInput--icon'}>
          <span
            style={{
              lineHeight: '38px',
            }}>
            {'#'}
          </span>
        </div>
        <input
          className={'HexInput--text'}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          placeholder={placeholder}
          style={{
            color: textColor,
          }}
        />
      </div>
    );
  }

  handleChange(event) {
    const {value} = event.target;

    // A user might enter a hex code with a hash
    // prepended, or not. Accept both.
    const hash = value.includes('#') ? '' : '#';
    const hex = `${hash}${value}`;

    let color;
    try {
      // Chroma doesn't provide explicit validation,
      // but if you try to create a new chroma
      // instance from an invalid hex code, an error
      // will be thrown and color will be undefined.
      color = chroma(hex);

      if (!this.state.isValid && hex.length === 7) {
        this.setState({
          isValid: true,
        });
      }
    } catch (error) {
      if (this.state.isValid) {
        this.setState({
          isValid: false,
        });
      }
    }

    if (color) {
      this.props.handleChange(color.hex(), false);
    }
  }

  handleKeyDown(event) {
    if (event.keyCode === keycode('Enter')) {
      const color = chroma(this.props.value);
      this.props.handleChange(color.hex(), true);
    }
  }
}
